document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.testimonial-slider').forEach(function (root) {
    var track = root.querySelector('[data-slider-track]');
    var prevBtn = root.querySelector('[data-slider-prev]');
    var nextBtn = root.querySelector('[data-slider-next]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-slide]')) : [];

    if (!track || !slides.length) return;

    function scrollByCard(direction) {
      var card = slides[0];
      var cardWidth = card.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      track.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    }

    function updateArrowState() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByCard(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByCard(1);
      });
    }

    var scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateArrowState, 80);
    });

    window.addEventListener('resize', updateArrowState);
    updateArrowState();

    // Reveal cards on scroll into view
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );
      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    } else {
      slides.forEach(function (slide) {
        slide.classList.add('is-visible');
      });
    }
  });
});
